<media-file [file]="file" [apiUrl]="config.uploadApiUrl" [gallery]="config.gallery" [uploadMaxFileSize]="config.uploadMaxFileSize" [fileUploadConfig]="config.upload" (onAdd)="add($event)" (onDelete)="delete()"></media-file>
<p *ngIf="config.help" class="message-help">{{ config.help }}</p>
<mat-error>
    <div *ngIf="form.controls[config.id].invalid && (form.controls[config.id].dirty || form.controls[config.id].touched)">
        <div *ngIf="form.controls[config.id].errors.required">{{ 'form.validation.error.required' | translate }}</div>
    </div>
</mat-error>
